import { render, staticRenderFns } from "./gtj.vue?vue&type=template&id=24184c5e&scoped=true&"
import script from "./gtj.vue?vue&type=script&lang=js&"
export * from "./gtj.vue?vue&type=script&lang=js&"
import style0 from "./gtj.vue?vue&type=style&index=0&id=24184c5e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!////node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24184c5e",
  null
  
)

export default component.exports